module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-bounce-in-left/wow-bounce-in-left.component.scss
// module id = ./src/app/features/wow-slider/wow-bounce-in-left/wow-bounce-in-left.component.scss
// module chunks = main